import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Mail, Lock, Eye, EyeOff } from 'lucide-react';
import FieldError from '../ui/FieldError';
import { validateRequired } from '../../utils/validation';

const LoginForm = ({ loginData, setLoginData, showLoginPassword, setShowLoginPassword, handleLogin, isLoading }) => {
  const [touched, setTouched] = useState({});
  const errors = {
    email: touched.email ? validateRequired(loginData.email, 'Email or username') : '',
    password: touched.password ? validateRequired(loginData.password, 'Password') : '',
  };

  const onSubmit = (e) => {
    setTouched({ email: true, password: true });
    handleLogin(e);
  };

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="login-email" className="portfolio-input-label">Email Address</Label>
        <div className="relative">
          <Mail className="absolute left-3 top-3 w-5 h-5 text-slate-400" />
          <Input id="login-email" data-testid="login-email-input" type="text" placeholder="Enter your email or username"
            value={loginData.email} onChange={(e) => setLoginData({ ...loginData, email: e.target.value })}
            onBlur={() => setTouched(t => ({ ...t, email: true }))}
            className={`pl-10 portfolio-input ${errors.email ? 'border-red-400' : ''}`} required />
        </div>
        <FieldError error={errors.email} />
      </div>
      <div className="space-y-2">
        <Label htmlFor="login-password" className="portfolio-input-label">Password</Label>
        <div className="relative">
          <Lock className="absolute left-3 top-3 w-5 h-5 text-slate-400" />
          <Input id="login-password" data-testid="login-password-input" type={showLoginPassword ? 'text' : 'password'} placeholder="Enter your password"
            value={loginData.password} onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
            onBlur={() => setTouched(t => ({ ...t, password: true }))}
            className={`pl-10 pr-10 portfolio-input ${errors.password ? 'border-red-400' : ''}`} required />
          <button type="button" tabIndex={-1} onClick={() => setShowLoginPassword(!showLoginPassword)} className="absolute right-3 top-3 text-slate-400 hover:text-slate-300">
            {showLoginPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
          </button>
        </div>
        <FieldError error={errors.password} />
        <div className="flex justify-end mt-1">
          <button type="button" onClick={() => window.location.href = '/forgot-password'} className="text-xs text-green-600 hover:text-green-700 hover:underline">Forgot password?</button>
        </div>
      </div>
      <Button type="submit" data-testid="login-submit-btn" disabled={isLoading} className="w-full portfolio-button-primary mt-6">
        {isLoading ? 'Signing In...' : 'Sign In'}
      </Button>
    </form>
  );
};

export default LoginForm;
